import { ProductAvailability } from '../components/ProductVariantPlanCard/types/types';

export const constructConnectionStatus = (
  productAvailability?: ProductAvailability['details'],
) => {
  if (productAvailability?.length === 0) return null;

  return productAvailability
    ?.map(({ offerCategory, status }) => `${offerCategory}:${status}`)
    .join(',');
};
